const EXPIRES_POSTFIX = "_expires";

export function getLocalStorage<T = any>(key: string): T | undefined;
export function getLocalStorage<T>(key: string, defaultValue: T): T;
export function getLocalStorage<T>(key: string, defaultValue?: T | undefined) {
	let storedValue = localStorage.getItem(key);
	if (storedValue) {
		return JSON.parse(storedValue);
	}
	storedValue = localStorage.getItem(`${key}${EXPIRES_POSTFIX}`);
	if (storedValue) {
		const value = JSON.parse(storedValue);
		if (new Date(value.expire) >= new Date()) {
			return value.value;
		} else {
			deleteLocalStorage(`${key}${EXPIRES_POSTFIX}`);
		}
	}
	return defaultValue;
}

export function localStorageHasKey(key: string): boolean {
	return localStorage.getItem(key) !== null;
}

export function setLocalStorage<T = any>(key: string, value: T, expire?: Date) {
	let storageKey = key;
	let storageValue: any = value;
	if (expire) {
		storageKey = `${key}${EXPIRES_POSTFIX}`;
		storageValue = { expire, value };
	}
	localStorage.setItem(storageKey, JSON.stringify(storageValue));
}

export function deleteLocalStorage(key: string) {
	localStorage.removeItem(key);
}

export function deleteLocalStorageExpired() {
	const keys = Object.keys(localStorage).filter((key) => key.endsWith(EXPIRES_POSTFIX));
	const iDag = new Date();
	for (const key of keys) {
		const storedValue = localStorage.getItem(key) ?? "";
		const value = JSON.parse(storedValue);
		const expire = new Date(value.expire);
		if (expire < iDag) {
			deleteLocalStorage(key);
		}
	}
}
